import { render, staticRenderFns } from "./OwnResources.vue?vue&type=template&id=00d786b4&scoped=true"
import script from "./OwnResources.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnResources.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OwnResources.vue?vue&type=style&index=0&id=00d786b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d786b4",
  null
  
)

export default component.exports